const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const ACCESS_EXPIRY_KEY = 'accessTokenExpiresAt';
const USER_KEY = 'user';
const REMEMBER_ME_TOKEN_KEY = 'rememberMeToken';
const REMEMBER_ME_EXPIRES_KEY = 'rememberMeExpiresAt';

const safeParse = (value) => {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const authStorage = {
  saveTokens({ accessToken, refreshToken, expiresIn }) {
    if (accessToken) {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    }

    if (typeof expiresIn === 'number') {
      const expiresAt = Date.now() + expiresIn * 1000;
      localStorage.setItem(ACCESS_EXPIRY_KEY, expiresAt.toString());
    }

    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }
  },

  saveRememberMe({ token, expiresAt }) {
    if (token) {
      localStorage.setItem(REMEMBER_ME_TOKEN_KEY, token);
    }

    if (expiresAt) {
      const expiry = typeof expiresAt === 'string' ? expiresAt : new Date(expiresAt).toISOString();
      localStorage.setItem(REMEMBER_ME_EXPIRES_KEY, expiry);
    }
  },

  getRememberMeToken() {
    return localStorage.getItem(REMEMBER_ME_TOKEN_KEY);
  },

  getRememberMeExpiry() {
    const raw = localStorage.getItem(REMEMBER_ME_EXPIRES_KEY);
    if (!raw) {
      return null;
    }

    const timestamp = Date.parse(raw);
    if (Number.isNaN(timestamp)) {
      return null;
    }

    return timestamp;
  },

  clearRememberMe() {
    localStorage.removeItem(REMEMBER_ME_TOKEN_KEY);
    localStorage.removeItem(REMEMBER_ME_EXPIRES_KEY);
  },

  saveUser(user) {
    if (!user) {
      localStorage.removeItem(USER_KEY);
      return;
    }
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  getUser() {
    return safeParse(localStorage.getItem(USER_KEY));
  },

  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  getAccessTokenExpiry() {
    const value = localStorage.getItem(ACCESS_EXPIRY_KEY);
    if (!value) {
      return null;
    }
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  },

  isAccessTokenExpired() {
    const expiry = this.getAccessTokenExpiry();
    if (!expiry) {
      return true;
    }
    return Date.now() >= expiry - 5_000;
  },

  clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ACCESS_EXPIRY_KEY);
    localStorage.removeItem(USER_KEY);
  },

  clear() {
    this.clearTokens();
    this.clearRememberMe();
  },
};

export default authStorage;
